export const filterObjectByKeys = (
  obj: any,
  keysToRemove: string[] = ['DateCreated', 'DateFrom', 'DateTo']
): any => {
  return Object.keys(obj)
    .filter((key) => !keysToRemove.includes(key))
    .reduce((acc, key) => Object.assign(acc, { [key]: obj[key] }), {})
}
